import styled from "styled-components";

export const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Input = styled.input`
  background-color: rgb(36, 36, 36);
  color: white;
  border: 1px solid black;
  border-radius: 5px;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 10px;
  margin: 2px;
`;

export const Button = styled.button`
  background-color: green;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
`;
